var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReserveOnline32 = function SvgReserveOnline32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.297 16.462 9.052 23 2 15.636l7.743-8.115A4.89 4.89 0 0 1 13.269 6a4.89 4.89 0 0 1 3.526 1.521A5.23 5.23 0 0 1 18 9.552",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.89 13.525a2.338 2.338 0 1 1 1.54-2.813",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.513 12.231a3.509 3.509 0 0 1-.246-.269l-.087-.105a4.227 4.227 0 0 1-.909-2.63M15 6.178a4.115 4.115 0 0 1 1.63-.98 4.175 4.175 0 0 1 3.675.568c.523.372.95.86 1.244 1.425a3.967 3.967 0 0 1 .01 3.651 4.047 4.047 0 0 1-1.237 1.432 4.143 4.143 0 0 1-1.764.726",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.817 17a3.51 3.51 0 0 1-.792-.635 3.81 3.81 0 0 1-.958-1.91 3.955 3.955 0 0 1 .2-2.153 3.688 3.688 0 0 1 1.289-1.674A3.35 3.35 0 0 1 18.5 10a3.35 3.35 0 0 1 1.944.628c.576.41 1.024.992 1.29 1.674.264.68.334 1.43.199 2.154a3.81 3.81 0 0 1-.958 1.909c-.235.25-.502.464-.792.635M20 17v9.047L18.168 28 16 26.047v-1.669l1.492-1.448L16 22.076l1.669-1.64L16 19.77l.003-2.77M7 15v2h4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.482A9.338 9.338 0 0 1 12 20m5-12.28A9.319 9.319 0 0 1 20.602 7h.146c.191 0 .382 0 .57.024a9.405 9.405 0 0 1 6.3 3.16 9.547 9.547 0 0 1 2.375 6.675 9.536 9.536 0 0 1-2.872 6.473A9.393 9.393 0 0 1 20.601 26",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13h-4v11m0-8h5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReserveOnline32;